<template>
    <div class="container mt-50 mb-50">

        <div class="section-title-3">
            <h2>Contactanos</h2>
            <p class="font500">Estamos encantados de escucharte y ponernos en contacto contigo</p>
        </div>

        <div class="clear mb-10"></div>

        <form class="contact-form" id="contactForm" method="get" action="#">

            <div class="row">

                <div class="col-sm-6">

                    <div class="form-group mb-25">
                        <input type="text" class="form-control" placeholder="Tu Nombre" name="yourname">
                    </div>

                    <div class="form-group mb-25">
                        <input type="email" class="form-control" placeholder="Email" name="contactEmail">
                    </div>

                    <div class="form-group mb-25">
                        <input type="text" class="form-control" placeholder="Asunto" name="subject">
                    </div>

                    <div class="form-group">
                        <input type="text" class="form-control" placeholder="Teléfono" name="Phone">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <textarea class="form-control" rows="8" placeholder="Mensaje" name="contactMessage"></textarea>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
            <div class="pull-right">
                <input type="submit" class="btn" value="Enviar">
            </div>
        </form>
        <div class="clear"></div>
    </div>
</template>
<script>
    export default {
        name: 'contactForm'
    }
</script>
<style scoped>
    .btn {
        background: #8ac6c4 !important;
        color: #FFF !important;
    }

    .btn:hover {
        background: #99D3FF !important;
        border-color: #8ac6c4 !important;
    }
</style>